import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();

export default {
  async getAll(search = null, page = 1, pageSize = 200) {
    try {
      getUxStore().startLoading();
      const params = { page, pageSize };
      if (search) params.search = search;
      return await apiClient.get("/article", { params });
    } catch (error) {
      console.error("Error in ArticleService.getAll:", error);
      getUxStore().setError("Fehler beim Laden der Artikel.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getById(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.get(`/article/${id}`);
    } catch (error) {
      console.error("Error in ArticleService.getById:", error);
      getUxStore().setError("Fehler beim Laden des Artikels.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async create(payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/article", payload);
    } catch (error) {
      console.error("Error in ArticleService.create:", error);
      getUxStore().setError("Fehler beim Erstellen des Artikels.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async update(id, payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/article/${id}`, payload);
    } catch (error) {
      console.error("Error in ArticleService.update:", error);
      getUxStore().setError("Fehler beim Aktualisieren des Artikels.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async remove(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.delete(`/article/${id}`);
    } catch (error) {
      console.error("Error in ArticleService.remove:", error);
      getUxStore().setError("Fehler beim Löschen des Artikels.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async export(format = "json") {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/article/export?format=${encodeURIComponent(format)}`);
    } catch (error) {
      console.error("Error in ArticleService.export:", error);
      getUxStore().setError("Fehler beim Export der Artikel.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async import(fileId, upsert = true) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/article/import", { fileId, upsert });
    } catch (error) {
      console.error("Error in ArticleService.import:", error);
      getUxStore().setError("Fehler beim Import der Artikel.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
